import { AuthorContent } from '@silvertours/back-domain-page';
import { useTranslations } from 'next-intl';
import {
  Wrapper,
  ImageWrapper,
  StyledImage,
  AuthorWrapper,
  AuthorText,
  AuthorTitle,
  AuthorName,
  AuthorLink,
} from './Author.styles';

const Author = ({ name, text, image, role, url }: AuthorContent) => {
  const t = useTranslations('features.article');
  return (
    <Wrapper id="author">
      <ImageWrapper>
        {image && (
          <StyledImage src={image.src} alt="" width="128" height="128" />
        )}
      </ImageWrapper>
      <AuthorWrapper>
        <AuthorTitle>{role}</AuthorTitle>
        <AuthorName>{name}</AuthorName>
        <AuthorText>{text} </AuthorText>
        {url && (
          <AuthorLink href={url}>
            {t('author.linkText')} {name}
          </AuthorLink>
        )}
      </AuthorWrapper>
    </Wrapper>
  );
};
export { Author };
